<template>
  <div class="list-group">
    <div v-for="reservation in reservations" :key="reservation.number" class="list-group-item">
      <router-link :to="{name: 'reservationDetail', params: {id: reservation.number}}">{{ reservation.number }}</router-link>
      {{ reservation.startTime | dateTime }}
      <reservation-state :reservation="reservation"></reservation-state>
    </div>
  </div>
</template>

<script>

import ReservationState from "@/components/reservation/ReservationState";

export default {
  components: {ReservationState},
  props: {
    reservations: Array
  }
}
</script>
